export default __webpack_public_path__ + "static/logo-655f9c2c16e7f1bd48bacbc42df185f2.png";